// import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';
import synthesizeFormMixins from '../mixins/synthesize-form.js';
export default {
  mixins: [synthesizeFormMixins],
  props: ['projectInfo'],
  data() {
    return {
      bidGeneralSituation: 4, // 水面经营权
      massifs: [
        {
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: '',
          certificateNo: '',
          endTime: ''
        }
      ],
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入面积', trigger: 'blur' }
        ],
        originalPurpose: [
          { required: true, message: '请输入原用途', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入附属设施及其他情况', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    priceVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入价格'));
      } else if(value < 1 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    areaVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入面积'));
      } else if(value < 1 || value > 99999.99){
        callback(new Error('请输入0-100000以内的数字'));
      } else {
        callback();
      }
    },
    clear(){
      if( this.projectInfo.projectType === 3) return false;
      console.log(this.projectInfo);
      this.massifs = [
        {
          massifName: '',
          area: null,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: ''
        }
      ];
      // 清空红色必填标示
      if(this.$refs['waterForm']) {
        this.$refs['waterForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        price: null,
        originalPurpose: '',
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        attachment: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    }
    // test() {
    //   return new Promise((resolve, reject) => {
    //     let num = 0;
    //     this.massifs.forEach((form, index) => {
    //       form.price = 0;
    //       this.$refs[`landForm${index}`][0].validate((valid) => {
    //         if (valid) {
    //           num ++;
    //         } else {
    //           reject();
    //         }
    //       });
    //     });
    //     if (num === this.massifs.length) {
    //       resolve({
    //         massifs: JSON.parse(JSON.stringify(this.massifs)),
    //         ...this.totalForm,
    //         bidGeneralSituation: this.bidGeneralSituation
    //       });
    //     } else {
    //       reject();
    //     }
    //   });
    // }
  }
};
